export default __webpack_public_path__ + "static/media/cover_4.9b553748.jpg";